import { render, staticRenderFns } from "./VerMenuEle.vue?vue&type=template&id=1101b2a6&scoped=true"
import script from "./VerMenuEle.vue?vue&type=script&lang=js"
export * from "./VerMenuEle.vue?vue&type=script&lang=js"
import style0 from "./VerMenuEle.vue?vue&type=style&index=0&id=1101b2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1101b2a6",
  null
  
)

export default component.exports